import { Collapse, Stack } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { useEffect, useMemo, useState } from 'react';

import { SearchQuestionItem } from '@mygpt/app/chat/services';

import classes from './questionComplete.module.css';
import { useQuestionSuggestion } from '@mygpt/app/chat/stores/useQuestionSuggestion';
export const QuestionComplete = ({
  aiId,
  handleQuestionClick,
  inputFocus = true,
  question,
  submitLoading,
}: {
  question: string;
  aiId: string;
  handleQuestionClick: (item: SearchQuestionItem) => void;
  inputFocus: boolean;
  submitLoading: boolean;
}) => {
  const [selected, setSelected] = useState(false);
  const [debouncedSearch] = useDebouncedValue(question, 500);

  const { questionSuggestions, clear, searchQuestion } = useQuestionSuggestion();

  useEffect(() => {
    if (debouncedSearch.trim().length > 1) {
      setSelected(false);
      searchQuestion({
        aiId,
        search: debouncedSearch,
      });
    } else {
      clear();
    }
  }, [debouncedSearch]);

  const textFormat = (text: string) => {
    return text.replace(/<\/?em>/g, '');
  };

  const questionShow = useMemo(() => {
    return debouncedSearch.length > 1 && questionSuggestions.length > 0 && !selected && inputFocus && !submitLoading;
  }, [debouncedSearch, questionSuggestions, selected, inputFocus, submitLoading]);

  return (
    <div>
      <Collapse in={questionShow} className="absolute bottom-full w-full bg-white rounded-lg shadow-md mb-2">
        <Stack className="p-3" gap={0}>
          {questionSuggestions.map((item, index) => {
            return (
              <div
                key={index}
                className={`cursor-pointer hover:bg-violet-100 p-2 rounded-md text-sm ${classes['text']}`}
                onClick={() => {
                  setSelected(true);
                  handleQuestionClick({ id: item.id, question: textFormat(item.question) });
                }}
                dangerouslySetInnerHTML={{ __html: item.question }}
              ></div>
            );
          })}
        </Stack>
      </Collapse>
    </div>
  );
};
